import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const PaymentCancelled = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleRetry = () => {
    navigate('/'); // Zurück zur Hauptseite
  };

  const t = (key) => {
    const translations = {
      'payment_cancelled': { 'en': 'Payment Cancelled', 'de': 'Zahlung abgebrochen' },
      'payment_cancelled_message': { 'en': 'Your payment was cancelled. You can try again anytime.', 'de': 'Ihre Zahlung wurde abgebrochen. Sie können es jederzeit erneut versuchen.' },
      'retry': { 'en': 'Try Again', 'de': 'Erneut versuchen' }
    };
    return translations[key]?.[language] || key;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        <div className="text-yellow-500 text-6xl mb-4">⚠️</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {t('payment_cancelled')}
        </h1>
        <p className="text-gray-600 mb-8">
          {t('payment_cancelled_message')}
        </p>
        <button
          onClick={handleRetry}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          {t('retry')}
        </button>
      </div>
    </div>
  );
};

export default PaymentCancelled;
